export default "__VITE_ASSET__CbXf20xJ__"